import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { SButton, SDropdownV3, SIconButton, SIconType, SInputV2, SVariablePicker } from "../..";
import tw from "tailwind-styled-components";
import React from "react";
import { CSSReference } from "./helpers/cssReference";
import { kebabCase } from "es-toolkit";
const Wrapper = tw.div`
bg-grayscale-dark rounded-md border border-white/10
`;
export const CustomCSSEditor = ({ readOnly, value, onChangeValue, onClickValue })=>{
    const properties = value?.properties;
    const onChange = (v)=>{
        let defaults = {
            type: "property-custom-css",
            properties: []
        };
        const newValue = {
            ...defaults,
            ...value,
            ...v
        };
        onChangeValue && onChangeValue(newValue);
    };
    const editExecution = (index, property)=>{
        let existing = value?.properties || [];
        const customProperties = [
            ...existing.slice(0, index),
            {
                ...property
            },
            ...existing.slice(index + 1)
        ];
        onChange({
            ...value,
            properties: customProperties
        });
    };
    const addProperty = ()=>{
        const existing = value?.properties || [];
        const id = "action:" + Math.random().toString(36).substring(7);
        onChange({
            ...value,
            properties: [
                ...existing,
                {
                    type: "custom-css-property",
                    id,
                    property: "",
                    value: ""
                }
            ]
        });
    };
    const removeProperty = (index)=>{
        const existing = value?.properties || [];
        onChange({
            ...value,
            properties: [
                ...existing.slice(0, index),
                ...existing.slice(index + 1)
            ]
        });
    };
    return /*#__PURE__*/ _jsx("div", {
        onClick: onClickValue,
        children: /*#__PURE__*/ _jsx("div", {
            className: readOnly ? "pointer-events-none" : "",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "grid grid-cols-1 gap-2 items-center justify-stretch",
                children: [
                    properties?.map((property, index)=>{
                        return /*#__PURE__*/ _jsx(PropertyValueEditor, {
                            index: index,
                            onNext: ()=>{
                                if (index === properties.length - 1) {
                                    addProperty();
                                }
                                setTimeout(()=>{
                                    const nextId = `property-value-${index + 1}`;
                                    const nextInput = document.getElementById(nextId);
                                    console.log("[!] nextInput", nextId, nextInput);
                                    nextInput?.focus();
                                }, 100);
                            },
                            propertyValue: property,
                            onChange: (actionType)=>editExecution(index, actionType),
                            onDelete: ()=>removeProperty(index)
                        }, index);
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "grid grid-cols-1 items-center justify-center",
                        children: /*#__PURE__*/ _jsx(SButton, {
                            className: "col-span-2",
                            onClick: ()=>{
                                addProperty();
                                const index = properties === undefined ? 1 : properties.length;
                                setTimeout(()=>{
                                    const nextId = `property-value-${index}`;
                                    const nextInput = document.getElementById(nextId);
                                    console.log("[!] nextInput", nextId, nextInput);
                                    nextInput?.focus();
                                }, 100);
                            },
                            children: "+ Add Property"
                        })
                    })
                ]
            })
        })
    });
};
export const PropertyValueEditor = ({ propertyValue, onChange, index, onNext, onDelete })=>{
    const items = CSSReference.map((item)=>({
            name: kebabCase(item.name),
            key: item.name,
            state: item,
            subtitle: item.description
        }));
    const ref = React.useRef(null);
    const isSelectingRef = React.useRef(false);
    const scrollIntoView = ()=>{
        ref.current?.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
    };
    return /*#__PURE__*/ _jsx(SVariablePicker, {
        items: items,
        asButton: true,
        render: (item)=>{
            return /*#__PURE__*/ _jsxs("div", {
                className: "",
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        children: item.name
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-sm opacity-50 whitespace-wrap break-all",
                        children: item.state?.description
                    })
                ]
            });
        },
        buttonRender: ({ isOpen, setIsOpen })=>{
            return /*#__PURE__*/ _jsx(Wrapper, {
                children: /*#__PURE__*/ _jsxs("div", {
                    className: `grid grid-cols-[auto,1fr,auto,auto] ${propertyValue.property ? "gap-1" : "gap-0"} items-center px-2 h-[32px]`,
                    children: [
                        /*#__PURE__*/ _jsx(SDropdownV3, {
                            showIcon: false,
                            tabIndex: 1,
                            options: [],
                            className: "!h-[20px] pl-1 text-brand-primary",
                            value: propertyValue.property,
                            customOnClick: ()=>{
                                scrollIntoView();
                                setIsOpen(!isOpen);
                            },
                            onChange: (e)=>onChange({
                                    ...propertyValue,
                                    property: e.value
                                }),
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "text-brand-primary flex flex-row items-center",
                                children: propertyValue.property ? `${kebabCase(propertyValue.property)}:` : /*#__PURE__*/ _jsx(_Fragment, {})
                            })
                        }),
                        /*#__PURE__*/ _jsx(SInputV2, {
                            ref: ref,
                            borderless: true,
                            style: {
                            },
                            className: "!h-[20px] !py-0 !px-0",
                            type: "text",
                            id: `property-value-${index}`,
                            placeholder: propertyValue.property ? "value" : "Enter a CSS property",
                            tabIndex: 1,
                            value: propertyValue.value,
                            onKeyDown: (e)=>{
                                // if backspace and empty value, delete the property
                                if (e.key === "Backspace" && !propertyValue.value && !propertyValue.property) {
                                    // focus on the previous property
                                    if (index) {
                                        const prevId = `property-value-${index - 1}`;
                                        const prevInput = document.getElementById(prevId);
                                        console.log("[!] prevInput", prevId, prevInput);
                                        e.stopPropagation();
                                        e.preventDefault();
                                        prevInput?.focus();
                                    }
                                    onDelete();
                                    return;
                                }
                                if (!propertyValue.property) {
                                    scrollIntoView();
                                    setIsOpen(true);
                                    return;
                                }
                                if (e.key === "Enter") {
                                    onNext && onNext();
                                }
                            },
                            onChange: (e)=>onChange({
                                    ...propertyValue,
                                    value: e.target.value.replace(/;/g, "")
                                }),
                            onFocus: ()=>{
                                if (!propertyValue.property && !isSelectingRef.current) {
                                    scrollIntoView();
                                    setIsOpen(true);
                                }
                            },
                            readOnly: !propertyValue.property
                        }),
                        /*#__PURE__*/ _jsx(SIconButton, {
                            iconSize: 12,
                            isMinimal: true,
                            className: `!h-[15px] !w-[15px] !text-white/50 hover:!text-brand-primary !mr-1 ${propertyValue.property ? "" : "pointer-events-none opacity-0"} `,
                            icon: SIconType.Open,
                            onClick: ()=>{
                                // open the MDN link
                                const url = `https://developer.mozilla.org/en-US/docs/Web/CSS/${kebabCase(propertyValue.property)}`;
                                if (typeof window === "undefined") {
                                    return;
                                }
                                window.open(url, "css-property");
                            }
                        }),
                        /*#__PURE__*/ _jsx(SIconButton, {
                            iconSize: 12,
                            isMinimal: true,
                            className: "!h-[15px] !w-[15px] !text-white/50 hover:!text-brand-primary",
                            icon: SIconType.X,
                            onClick: onDelete
                        })
                    ]
                })
            });
        },
        didSelect: (item)=>{
            isSelectingRef.current = false;
            onChange({
                ...propertyValue,
                property: item.key
            });
            setTimeout(()=>{
                ref.current?.focus();
                ref.current?.select();
            }, 100);
        }
    });
};
